export type RedirectBuildResult =
  | { success: true; url: string }
  | { success: false; error: string };

const ALLOWED_REDIRECT_URIS = [
  'https://guestcenter.opentable.com/redirect',
  'https://gc-pp-rs.otenv.com/redirect',
];

export function buildRedirectUrl(
  code: string,
  state: string,
  redirectUri: string,
  targetPathOrUrl: string,
  workspaceId?: string,
  restaurantName?: string,
  restaurantRegion?: string,
): RedirectBuildResult {
  try {
    let target: URL;

    // Check if the input is a relative path (starts with "/")
    if (targetPathOrUrl.startsWith('/')) {
      // Build an app-internal URL (origin-relative)
      target = new URL(targetPathOrUrl, window.location.origin);

      target.searchParams.set('redirect_uri', redirectUri);
      target.searchParams.set('code', code);
      target.searchParams.set('state', state);
      target.searchParams.set('workspace_id', workspaceId ?? '');
      target.searchParams.set('name', restaurantName ?? '');
      target.searchParams.set('region', restaurantRegion ?? '');
    } else {
      // Assume absolute external URL
      target = new URL(redirectUri);

      if (!ALLOWED_REDIRECT_URIS.includes(target.origin + target.pathname)) {
        throw new Error('Redirect URI is not allowed.');
      }

      target.searchParams.set('code', code);
      target.searchParams.set('state', state);
    }

    return { success: true, url: target.toString() };
  } catch {
    return {
      success: false,
      error:
        'Invalid target URL. Must be a relative path or a valid absolute URL.',
    };
  }
}
